<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { frontendURL, conversationUrl } from 'dashboard/helper/URLHelper';

const store = useStore();
const router = useRouter();

const openTabs = computed(() => store.getters['conversationTabs/getOpenTabs']);
const activeChatId = computed(() => store.getters.getSelectedChat?.id);
const accountId = computed(() => store.getters.getCurrentAccountId);

const closeTab = (e, tab) => {
  e.stopPropagation();
  store.dispatch('conversationTabs/removeTab', tab.id);
  if (activeChatId.value === tab.id) {
    const tabs = openTabs.value;
    if (tabs.length > 0) {
      navigateToTab(tabs[tabs.length - 1]);
    } else {
      router.push(frontendURL(`accounts/${accountId.value}/dashboard`));
    }
  }
};

const navigateToTab = (tab) => {
  const url = conversationUrl({
    accountId: accountId.value,
    id: tab.id,
  });
  router.push(frontendURL(url));
};

const getIcon = (tab) => {
  if (tab.meta?.channel === 'Channel::Api') {
    return 'i-lucide-globe';
  } else if (tab.meta?.channel === 'Channel::Email') {
    return 'i-lucide-mail';
  } else if (tab.meta?.channel === 'Channel::WebWidget') {
    return 'i-lucide-message-square';
  }
  return 'i-lucide-check-circle';
};
</script>

<template>
  <div v-if="openTabs.length > 0" class="flex items-center w-full h-11 px-2 overflow-x-auto border-b bg-n-surface-1 border-n-weak shrink-0">
    <div
      v-for="tab in openTabs"
      :key="tab.id"
      class="flex items-center justify-between h-8 px-3 py-1 mx-1 text-sm transition-colors border rounded-md cursor-pointer shrink-0 max-w-[200px]"
      :class="[
        activeChatId === tab.id
          ? 'bg-n-background border-n-surface-1 font-medium text-n-slate-12 shadow-sm'
          : 'bg-n-surface-1 border-transparent text-n-slate-11 hover:bg-n-alpha-2 hover:text-n-slate-12'
      ]"
      @click="navigateToTab(tab)"
    >
      <div class="flex items-center min-w-0 mr-2">
        <Icon 
          :icon="getIcon(tab)" 
          class="mr-2 shrink-0 size-3.5" 
          :class="[activeChatId === tab.id ? 'text-n-brand' : 'text-n-slate-10']"
        />
        <span class="truncate">{{ tab.meta?.sender?.name || 'Conversation' }}</span>
      </div>
      <button 
        class="flex items-center justify-center rounded-full shrink-0 size-5 p-0 hover:bg-n-alpha-2 text-n-slate-11 hover:text-n-slate-12"
        @click.stop="closeTab($event, tab)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
  </div>
</template>
